var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 9.66659C7.70716 9.66659 8.38544 9.38563 8.88554 8.88554C9.38563 8.38544 9.66659 7.70716 9.66659 6.99992C9.66659 6.29267 9.38563 5.6144 8.88554 5.1143C8.38544 4.6142 7.70716 4.33325 6.99992 4.33325C6.29267 4.33325 5.6144 4.6142 5.1143 5.1143C4.6142 5.6144 4.33325 6.29267 4.33325 6.99992C4.33325 7.70716 4.6142 8.38544 5.1143 8.88554C5.6144 9.38563 6.29267 9.66659 6.99992 9.66659Z",
    stroke: "#F6AF3E",
    strokeOpacity: 0.45,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.66667V4.33333C1 3.44928 1.35119 2.60143 1.97631 1.97631C2.60143 1.35119 3.44928 1 4.33333 1H9.66667C10.5507 1 11.3986 1.35119 12.0237 1.97631C12.6488 2.60143 13 3.44928 13 4.33333V9.66667C13 10.5507 12.6488 11.3986 12.0237 12.0237C11.3986 12.6488 10.5507 13 9.66667 13H4.33333C3.44928 13 2.60143 12.6488 1.97631 12.0237C1.35119 11.3986 1 10.5507 1 9.66667Z",
    stroke: "#F6AF3E",
    strokeOpacity: 0.45,
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 3.34101L10.6742 3.33276",
    stroke: "#F6AF3E",
    strokeOpacity: 0.45,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.494f6a4496ec7da332c739bc97b613ca.svg";
export { ForwardRef as ReactComponent };